import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function TravellerGamification() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Gamification</Heading>
      <Accordion size="large" heading="How does the gamification program work? ">
        <BodyText variant="large">
          The gamification program is designed to encourage employees to spend under their company's allocated budget for flights or accommodation, rewarding them with Luxury Escapes Credits for personal travel. Here's how it works:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">Spending Under Budget:</BodyText>
              <BodyText variant="large"> If your company has opted in for Gamification, you have the option to select flights or accommodation that are less than your allocated budget for business travel.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Earning Luxury Escapes Credits:</BodyText>
              <BodyText variant="large"> For every dollar saved under the budget, employees earn a percentage (designated by your company) of the savings back as Luxury Escapes credits. The more you save, the more credits you can earn.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Personal Travel Rewards:</BodyText>
              <BodyText variant="large"> These Luxury Escapes credits are available once you have completed your business trip and can then be used by employees for their personal travel bookings on the Luxury Escapes platform. This allows employees to enjoy rewards for their cost-saving efforts during business travel.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
      <Accordion size="large" heading="Am I paying for the credits? ">
        <BodyText variant="large">
          Credits earned through Business Traveller are typically paid for at checkout when making a booking.
        </BodyText>
        <BodyText variant="large">
          Here's how it works:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">Payment Method:</BodyText>
              <BodyText variant="large"> The payment for the credits can be covered by your company if you use a company card for the transaction. In this case, the cost of the credits is added to the gross total of the booking and paid for by the company.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Reimbursement:</BodyText>
              <BodyText variant="large"> Alternatively, if you pay for the credits yourself using a personal payment method, such as a personal credit card, you may be reimbursed by your company for the expense. This reimbursement process would depend on your company's reimbursement policies and procedures.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
      <Accordion size="large" heading="How can I redeem credits?">
        <BodyText variant="large">
          After your business trip has been completed, any credits earned will be applied within 2 business days to your designated personal Luxury Escapes account.
        </BodyText>
        <br />
        <BodyText variant="large">
          You may then use the credits earned on any product offered on the Luxury Escapes platform.
        </BodyText>
      </Accordion>
      <Accordion size="large" heading="Can I transfer my Luxury Escapes personal credits to another account? ">
        <BodyText variant="large">
          No, it is not possible to transfer Luxury Escapes personal credits earned through Business Traveller to another account. These credits are specifically assigned to the designated personal account and cannot be transferred to another person or account.
        </BodyText>
        <br />
        <BodyText variant="large">
          If you have any further questions or require assistance regarding the management or redemption of your Luxury Escapes credits, please reach out to our Customer Support team for guidance.
        </BodyText>
      </Accordion>
    </Group>
  )
}
